import type { TagCategory } from '../../api/trainingBlockApi'

/** Selected tag keys grouped by category. Empty / missing category = no filter for that category. */
export type TagCategoryFilterState = Partial<Record<TagCategory, Set<string>>>

export function emptyTagCategoryFilterState(): TagCategoryFilterState {
  return {}
}

export function isTagCategoryFilterActive(filters: TagCategoryFilterState): boolean {
  return Object.values(filters).some(set => set != null && set.size > 0)
}

/** AND across categories; OR within each category. */
export function matchesTagCategoryFilters(
  itemTags: string[] | null | undefined,
  filters: TagCategoryFilterState,
): boolean {
  const tags = itemTags ?? []
  const active = Object.values(filters).filter((set): set is Set<string> => set != null && set.size > 0)
  if (active.length === 0) return true
  return active.every(selected => tags.some(tag => selected.has(tag)))
}
